import AppStoreContext from 'contexts/AppStoreContext';
import React from 'react';
import Dropzone from 'react-dropzone';

interface State {
  uploading: boolean;
  message: string;
}

class IAUploadDocPage extends React.Component<{}, State> {
  static contextType = AppStoreContext;

  state = {
    uploading: false,
    message: '',
  };

  handleDocDrop = async (documents: File[]): Promise<void> => {
    try {
      const { selectedProject } = this.context.state;

      this.setState({ uploading: true });

      for (const doc of documents) {
        await this.context.actions.uploadDocument(selectedProject, doc);
      }

      this.setState({
        uploading: false,
        message: 'Success!',
      });
    } catch (e) {
      this.setState({
        uploading: false,
        message: `Something went wrong: ${e}`,
      });
    }
  };

  render(): React.ReactNode {
    const { uploading, message } = this.state;

    return (
      <div className="p4">
        <h1 className="mb4">Document Upload</h1>
        {uploading ? (
          <div>uploading....</div>
        ) : (
          <div>
            <Dropzone onDrop={this.handleDocDrop}>
              {({
                getRootProps,
                getInputProps,
                isDragActive,
              }): React.ReactElement => (
                <div className="vw40" {...getRootProps()}>
                  <input {...getInputProps()} type="file" />
                  <div className="b-dashed b-radius-3 p4 flex-center">
                    {isDragActive
                      ? 'Dropping'
                      : 'Drop your document here, or click to select your documents'}
                  </div>
                </div>
              )}
            </Dropzone>
            <div className="mt4">{message}</div>
          </div>
        )}
      </div>
    );
  }
}

export default IAUploadDocPage;
